import { useContext } from 'react';
import expressionEvaluatorContext, { ExpressionEvaluatorContext } from '../expressionEvaluatorContext';

const useExpressionEval = (): ExpressionEvaluatorContext => {
    const expressionEvalContext = useContext(expressionEvaluatorContext);
    return expressionEvalContext.impl;
};
export default useExpressionEval;
